import { Schoolyear } from 'types/schoolyear';
import setDateAtAnotherDate from 'utils/time/setDateAtAnotherDate';
import { getCurrentDayForSchoolyear } from '../utils/schoolyearDateUtils';
import { CJEvent } from 'types/event';

export function computeDatePickerSelectedDate({
  oppositeDate,
  singleSelectedSeance,
  schoolyear,
}: {
  oppositeDate: Date;
  singleSelectedSeance?: CJEvent;
  schoolyear: Schoolyear;
}) {
  // adapt the date to the schoolyear (based on periodes)
  const dateForSchoolyear =
    getCurrentDayForSchoolyear(oppositeDate, schoolyear) || oppositeDate;

  // if there is a single selected seance, use its time for the destination
  if (singleSelectedSeance?.start) {
    return setDateAtAnotherDate(singleSelectedSeance.start, dateForSchoolyear);
  }
  return dateForSchoolyear;
}
